<template>
<div v-if="needPasswordLogin">
        <form class="login-form form-margin-username" name="loginForm"  novalidate>
            <div class="form-group">
                <div class="input-group">
                    <input material-animation type="text" v-on:focus="nameFocus = true" v-on:blur="nameFocus = false" v-model="user.username" class="form-control" aria-describedby="sizing-addon2" name="username" required>
                    <div class="input-label" v-bind:class="{ active: nameFocus || user.username }">Username</div>
                </div>
                
            </div>
            <div class="form-group">
                <div class="input-group">
                    <input material-animation type="password" class="form-control" v-on:focus="passwordFocus = true" v-on:blur="passwordFocus = false" v-model="user.password" aria-describedby="sizing-addon2" name="password" required pattern='/^[a-zA-Z0-9!@#$%^&*.]{1,25}$/'>
                    <div class="input-label" v-bind:class="{ active: passwordFocus || user.password }">Password</div>
                </div>
            </div>
            <div class="form-group m-b-0">
                <button type="button" class=" m-b-0 pull-right btn btn-red btn-lg btn-block password-signin-btn" @click="localLogin(user)" v-bind:disabled="!signInValidation()">SIGN IN</button>
            </div>
            <a class="forgot-password-text" @click="forgotPassword('forgot')">
                Forgot your password?
            </a>
        </form>
    </div>
 
</template>

<script>
import umsinit from './../mixins/umsinit';

export default {

  name: 'LocalLogin',
  props: [ 'needPasswordLogin' ],
  data () {
    return {
        user : {
            username: '',
            password: ''
        },
        nameFocus : false,
        passwordFocus:false
    }
  },

  methods : {
    localLogin(user){
        this.$emit('localLogin', user);
    },
    forgotPassword(loginType){
        this.$emit('selectedLoginMethod', loginType);
    },
    signInValidation(){
        let validate = false;
        if(this.user.username && this.user.password){
            validate = true;
        }
        return validate;
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/LocalLogin.vue